<template>
    <div>
        <!--<span class="separator" v-if="columns.length !== 0"></span>-->
        <div class="result_container">
            <div v-for="(col,i) in columns" :key="'col_'+i" class="result_row" :class="{disabled: !editable}">
                <div class="column_name">{{col.display_name}}</div>
                <div class="filter_values">
                    <InfoBubble :deletable="editable" v-for="(value, j) in filter_values(col)"
                                :key="'filter_value_'+j" :is-filled="editable" :disabled="!editable"
                                @bubbleDeleted="deleteFilterValue({
                            column: col,
                            deletedItem: value})"
                    >
                        {{value}}
                    </InfoBubble>
                </div>
            </div>
        </div>
        <!--<span class="separator" v-if="columns.length !== 0"></span>-->
    </div>
</template>

<script>
    import InfoBubble from "../../../../components/inputs/InfoBubble";
    import Utils from "../../../../scripts/utils";

    export default {
        name: "PresetResult",
        components: {InfoBubble},
        props: {
            columns: {
                type: Array,
                required: true
            },
            editable: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            deleteFilterValue(value) {
                let ret = {column: JSON.parse(JSON.stringify(value.column))};
                let filter_value = Utils.toArray(ret.column.pivot.filter_value);
                let index = filter_value.findIndex(x => x === value.deletedItem);
                if (index !== -1) filter_value.splice(index, 1);
                ret.filter_value = filter_value;
                this.$emit('update', ret);
            },
            filter_values(col) {
                if (Object.keys(col).length !== 0) {
                    return Utils.toArray(col.pivot.filter_value);
                } else {
                    return [];
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .separator {
        display: flex;
        border-top: 6px solid rgba(208, 212, 218, 0.5);
        margin: 10px 76px 10px 0;
    }

    .result_container {
        display: flex;
        flex-flow: column;
        margin-right: 80px;

        .result_row {
            display: flex;
            flex-flow: row;
            width: 100%;
            padding: 7px 15px 7px 10px;

            &.disabled{
            padding-left: 0;
            }

            &:not(:last-child) {
                border-bottom: 1px solid #d0d4da;
            }

            .column_name {
                min-width: 150px;
                font-weight: 500;
                padding-right: 10px;
                padding-top: 5px;
            }

            .filter_values {
                display: flex;
                flex-flow: wrap;
                word-break: break-word;
                max-width: 80%;

              :deep(.infoBubble) {
                    width: max-content;
                    font-size: 15px;
                    margin-top: 5px;

                    .close {
                        margin-top: 2px;
                    }
                }
            }
        }
    }
</style>